<div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="headlines">
        <span *ngIf="!isPortraitDevice" class="text-headline-title">
            {{ authDataTitle | translate }}
        </span>

        <span class="text-paragraph">
            {{ authDataSubtitle1 | translate }}
        </span>
    </div>

    <form class="form" [formGroup]="formGroup">
        <div class="texto">
            <input type="checkbox" formControlName="auth" id="auth" class="box" (change)="onChangeDataAuthentication($event)" />
            <label class="text-paragraph-description" for="auth">{{ checkAuthData | translate }}</label>
        </div>
    </form>

    <div class="actions">
        <button
            *ngIf="!isPortraitDevice"
            pripple=""
            class="button-secondary button-next"
            type="button"
            [disabled]="backButtonDisabled"
            (click)="onClicButtonBack()"
        >
            <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
            <span class="p-button-label-right">{{ backButton | translate }}</span>
        </button>

        <button
            pripple=""
            class="button-primary button-next"
            type="button"
            [disabled]="continueButtonDisabled"
            (click)="onClicButtonContinue()"
            [ngClass]="{ 'is-portrait': isPortraitDevice }"
        >
            <span class="p-button-label-left">{{ continueButton | translate }}</span>
            <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
        </button>
    </div>

    <div class="text-info">
        <table class="info">
            <tr>
                <td class="warning"><i class="ri-information-line"></i></td>
                <td class="text-description">{{ infoAuthData | translate }}</td>
            </tr>
        </table>
    </div>
</div>
